module.exports = __webpack_public_path__ + "static/media/filename (17).9c9f8922.png";